import { render, staticRenderFns } from "./StatisticalAnalysis_Index.vue?vue&type=template&id=bba63c58&scoped=true"
import script from "./StatisticalAnalysis_Index.vue?vue&type=script&lang=js"
export * from "./StatisticalAnalysis_Index.vue?vue&type=script&lang=js"
import style0 from "./StatisticalAnalysis_Index.vue?vue&type=style&index=0&id=bba63c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba63c58",
  null
  
)

export default component.exports